const AnnotationNamesConfig = {
    POPULATION_FREQUENCY: "Population Frequency",
    DISEASE_DATABASES: "Disease Databases",
    COMPUTATIONAL_PREDICTIVE_PROGRAMS: "Computational Predictive Programs",
    NUCLEOTIDE_CONSERVATION: "Nucleotide Conservation",
};

export default AnnotationNamesConfig;